import React from 'react'
import { Spinner } from './Spinner'

export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger'
export type ButtonSize    = 'sm' | 'md' | 'lg'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant
  size?: ButtonSize
  loading?: boolean
  fullWidth?: boolean
}

const BUTTON_BASE: React.CSSProperties = {
  display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '0.4rem',
  fontWeight: 600, borderRadius: '8px', border: 'none', cursor: 'pointer',
  transition: 'opacity 0.15s, background 0.15s', whiteSpace: 'nowrap', flexShrink: 0,
}

const BUTTON_SIZES: Record<ButtonSize, React.CSSProperties> = {
  sm: { padding: '0.3rem 0.75rem',  fontSize: '0.78rem' },
  md: { padding: '0.55rem 1.25rem', fontSize: '0.875rem' },
  lg: { padding: '0.7rem 1.75rem',  fontSize: '1rem' },
}

const BUTTON_VARIANTS: Record<ButtonVariant, React.CSSProperties> = {
  primary:   { background: 'var(--accent-primary)',  color: 'white',                border: 'none' },
  secondary: { background: 'var(--bg-elevated)',     color: 'var(--text-secondary)', border: '1px solid var(--border)' },
  ghost:     { background: 'transparent',            color: 'var(--text-muted)',     border: '1px solid var(--border)' },
  danger:    { background: 'transparent',            color: 'var(--status-error)',   border: '1px solid var(--status-error)' },
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant = 'primary', size = 'md', loading, fullWidth, disabled, style, children, ...rest }, ref) => {
    const isDisabled = disabled || loading
    return (
      <button ref={ref} disabled={isDisabled} style={{ ...BUTTON_BASE, ...BUTTON_SIZES[size], ...BUTTON_VARIANTS[variant], width: fullWidth ? '100%' : undefined, opacity: isDisabled ? 0.55 : 1, cursor: isDisabled ? 'not-allowed' : 'pointer', ...style }} {...rest}>
        {loading ? <Spinner size={14} /> : null}
        {children}
      </button>
    )
  }
)
Button.displayName = 'Button'
